<template>
  <div class="table-container" style="padding-bottom: 0px;">
    <!-- 查询表单 -->
    <el-form ref="form" :model="queryForm" :inline="true" label-width="auto" @submit.native.prevent>
      <el-form-item label="用户编号">
        <el-input v-model="queryForm.user_code" placeholder="请输入用户编号" style="width: 140px" clearable
          @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item label="支付流水号">
        <el-input v-model="queryForm.pay_code" style="width: 220px" placeholder="请输入账号" clearable
          @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item label="订单编号">
        <el-input v-model="queryForm.order_code" style="width: 220px" placeholder="请输入订单编号" clearable
          @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item label="支付状态">
        <el-select v-model="value" clearable placeholder="请选择" style="width: 140px" @keyup.enter.native="handleQuery">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="支付时间">
        <el-date-picker v-model="time" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
          @change="handleDateChange"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" native-type="submit" @click="handleQuery">
          查询
        </el-button>
      </el-form-item>
    </el-form>

    <!-- 表格 -->
    <el-table ref="tableSort" v-loading="listLoading" :data="list" :element-loading-text="elementLoadingText"
      :height="height" border @selection-change="setSelectRows">
      <el-table-column show-overflow-tooltip type="selection" width="55" align="center"></el-table-column>
      <el-table-column align="center" show-overflow-tooltip prop="nickname" label="用户昵称"></el-table-column>
      <el-table-column align="center" show-overflow-tooltip prop="user_code" label="用户编号"></el-table-column>
      <el-table-column align="center" show-overflow-tooltip prop="pay_code" label="支付流水号"></el-table-column>
      <el-table-column align="center" show-overflow-tooltip prop="order_code" label="订单编号"
        width="400"></el-table-column>
      <el-table-column align="center" show-overflow-tooltip prop="total_price" label="价格"></el-table-column>
      <el-table-column show-overflow-tooltip prop="status" label="支付状态" align="center">
        <template #default="{ row }">
          <el-tag v-if="row.status == 1" size="mini" type="success">已支付</el-tag>
          <el-tag v-if="row.status == 3" size="mini" type="danger">已退款</el-tag>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="支付时间" prop="pay_time" align="center"></el-table-column>
      <el-table-column fixed="right" label="操作" width="120" align="center">
        <template #default="{ row }">
          <!-- 已支付显示退款按钮 -->
          <el-button v-if="row.status == 1" type="text" @click="handleAction(row)" style="color: #E6A23C;">退款</el-button>
          <!-- 已退款显示详情按钮 -->
          <el-button v-if="row.status == 3" type="text" @click="handleAction(row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination :background="background" :current-page="queryForm.page" :layout="layout"
      :page-sizes="[20, 50, 100, 200, 300, 400, 500]" :page-size="queryForm.limit" :total="total"
      @current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>

    <!-- ========== 退款弹窗（用于已支付订单） ========== -->
    <el-dialog :visible.sync="dialogVisible_tui" title="退款" width="40vw">
      <el-form ref="dialogForm" :model="tui_info" label-width="85px" :rules="rules" @submit.native.prevent>
        <el-form-item label="订单总金额">
          <el-input v-model="tui_info.total_price" style="width: 100%" disabled />
        </el-form-item>
        <el-form-item label="退款金额">
          <el-input v-model="tui_info.total_price" style="width: 100%" disabled />
        </el-form-item>
        <el-form-item label="退款备注" prop="refund_remarks">
          <el-input v-model="tui_info.refund_remarks" type="textarea" :rows="2" placeholder="请输入退款备注(必填)"
            style="width: 100%" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible_tui = false">取消</el-button>
        <el-button type="primary" :loading="tui_loading" @click="tuiKuan">确认退款</el-button>
      </div>
    </el-dialog>

    <!-- ========== 退款详情弹窗（用于已退款订单） ========== -->
    <el-dialog :visible.sync="dialogVisible_detail" title="退款详情" width="40vw">
      <el-form :model="detail_info" label-width="85px">
        <el-form-item label="订单总金额">
          <el-input v-model="detail_info.total_price" style="width: 100%" disabled />
        </el-form-item>
        <el-form-item label="退款金额">
          <el-input v-model="detail_info.total_price" style="width: 100%" disabled />
        </el-form-item>
        <el-form-item label="退款备注">
          <el-input v-model="detail_info.refund_remarks" style="width: 100%" disabled />
        </el-form-item>
        <el-form-item label="退款时间">
          <el-input v-model="detail_info.add_time" style="width: 100%" disabled />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible_detail = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  orderTaxList,
  oexcelOutPay,
  payUpdate,
  uploadFileCw,
  taxRefund,
  application_refund_part
} from '@/api/xgcApi'
import { baseURL_print, getUploadUrl } from '@/config'

export default {
  name: 'ManagePay',
  data() {
    return {
      // 退款弹窗
      dialogVisible_tui: false,
      tui_info: {},
      tui_loading: false,
      // 退款详情弹窗
      dialogVisible_detail: false,
      detail_info: {},
      // 其他
      payType: '',
      height: '80vh',
      uploadFileUrl: baseURL_print + 'index/index/file',
      list: [],
      background: true,
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      elementLoadingText: '正在加载...',
      queryForm: {
        page: 1,
        limit: 20,
        status: '1',
        kor_type: 0,
        pay_type: '',
        user_code: '',
        pay_code: '',
        order_code: '',
        start_time: '',
        end_time: '',
      },
      value: '1',
      value1: '',
      options: [
        { value: '1', label: '已支付' },
        { value: '3', label: '已退款' }
      ],
      time: [],
      rules: {
        refund_remarks: [{ required: true, trigger: 'blur', message: '请输入退款备注' }],
      },
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    handleEdit1(index, row) {
      payUpdate(row).then((res) => {
        if (res.code === 200) {
          this.$message({ message: res.msg, type: 'success' })
        } else {
          this.$message({ message: res.msg, type: 'error' })
        }
        this.fetchData()
      })
    },

    // ========== 统一处理操作按钮点击 ==========
    handleAction(row) {
      if (row.status === 1) {
        // 打开退款弹窗
        this.dialogVisible_tui = true
        this.tui_info = { ...row, refund_remarks: '' }
        this.$nextTick(() => {
          if (this.$refs.dialogForm) {
            this.$refs.dialogForm.clearValidate()
          }
        })
      } else if (row.status === 3) {
        // 打开详情弹窗
        this.dialogVisible_detail = true
        // 复制行数据，若字段不全可自行补充默认值
        this.detail_info = { ...row }
        this.detail_info.refund_remarks = this.detail_info.order_pay_refund[0].refund_remarks
        this.detail_info.add_time = this.detail_info.order_pay_refund[0].add_time
      }
    },

    // ========== 确认退款（含二次确认） ==========
    tuiKuan() {
      this.$refs.dialogForm.validate(async (valid) => {
        if (!valid) return false

        try {
          await this.$confirm('确定要对此订单进行退款吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
        } catch (cancel) {
          return
        }

        this.tui_loading = true
        const date = {
          id: this.tui_info.id,
          type: 5
        }
        try {
          const { msg } = await application_refund_part(date)
          // 若需要调用 taxRefund，请根据实际业务调整
          // const { msg } = await taxRefund(this.tui_info)
          this.$message({ message: msg || '退款成功', type: 'success' })
          this.dialogVisible_tui = false
          this.fetchData()
          this.tui_info = {}
        } catch (error) {
          console.error('退款失败:', error)
          this.$message.error('退款失败，请重试')
        } finally {
          this.tui_loading = false
        }
      })
    },

    handleDateChange(value) {
      if (value) {
        this.queryForm.start_time = value[0]
        this.queryForm.end_time = value[1]
      } else {
        this.queryForm.start_time = ''
        this.queryForm.end_time = ''
      }
    },

    exportForm() {
      if (this.selectRows.length > 0) {
        this.$baseConfirm('确定导出已选', null, async () => {
          const ids = this.selectRows.map((item) => item.id).join()
          const { data } = await oexcelOutPay({ id: ids })
          const fileUrl = getUploadUrl + data
          window.open(fileUrl)
          this.$message({ type: 'success', message: '导出成功' })
        })
      } else {
        this.$baseMessage('未选中任何行', 'error')
      }
    },

    async handleChange(file, fileList) {
      if (file.response) {
        let strurl = file.response.replace(/\\/g, '/')
        const { code, msg } = await uploadFileCw({ file: strurl })
        if (code === 200) {
          this.$message({ type: 'success', message: '导入成功' })
          this.fetchData()
        } else {
          this.$baseMessage('导入失败')
        }
      }
    },

    setSelectRows(val) {
      this.selectRows = val
    },

    handleSizeChange(val) {
      this.queryForm.limit = val
      this.fetchData()
    },

    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },

    handleQuery() {
      this.queryForm.page = 1
      this.queryForm.status = this.value
      this.queryForm.type = this.value1
      this.fetchData()
    },

    async fetchData() {
      this.listLoading = true
      try {
        const res = await orderTaxList(this.queryForm)
        this.list = (res.data?.list || []).filter(item => item.status !== 0)
        this.total = res.data?.count || 0
      } catch (error) {
        console.error('加载数据失败:', error)
        this.$message.error('数据加载失败，请刷新重试')
      } finally {
        this.listLoading = false
      }
    }
  },
}
</script>

<style scoped>
:deep .right-panel {
  display: flex;
  align-items: center;
}

:deep .el-form-item--small.el-form-item {
  margin-bottom: 10px !important;
}
</style>